import React from "react";
import SideMenu, { SideMenuLink, SideMenuSpacer } from "@amzn/meridian/esm/components/side-menu";
import Row from "@amzn/meridian/esm/components/row";
import { Text, Theme } from "@amzn/meridian";

import { CLIENT_TAB, CLIENT_TAB_LABEL } from "../mainClient.constants";
import { THEME_COLOR } from "../../../styles/colors";

const SidebarInClient = ({ selectedTab, setSelectedTab, isVerboseSummariesEnabled }) => {
  const settingsTab = isVerboseSummariesEnabled ? CLIENT_TAB.SETTINGS : CLIENT_TAB.HELP;
  const settingsLabel = isVerboseSummariesEnabled ? CLIENT_TAB_LABEL.SETTINGS : CLIENT_TAB_LABEL.FEEDBACK;

  return (
    <Theme
      tokens={{
        sideMenuLinkIndicatorColorSelected: THEME_COLOR.LIGHT_TEAL,
        sideMenuLinkIndicatorColorPressed: THEME_COLOR.SEAFOAM_GREEN,
      }}
    >
      <SideMenu width="176px">
        <SideMenuLink selected={selectedTab === CLIENT_TAB.SUMMARIES} onClick={() => setSelectedTab(CLIENT_TAB.SUMMARIES)}>
          <Row spacingInset="none none none 450">
            <Text>{CLIENT_TAB_LABEL.SUMMARIES}</Text>
          </Row>
        </SideMenuLink>
        <SideMenuLink selected={selectedTab === settingsTab} onClick={() => setSelectedTab(settingsTab)}>
          <Row spacingInset="none none none 450">
            <Text>{settingsLabel}</Text>
          </Row>
        </SideMenuLink>
        {[...Array(13)].map((_, idx) => (
          <SideMenuSpacer key={idx} />
        ))}
      </SideMenu>
    </Theme>
  );
};

export default SidebarInClient;
